"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var ExternalLink_1 = require("../../components/globals/ExternalLink");
var AppHeader_1 = require("../../components/globals/AppHeader");
var Policy_1 = require("../../components/globals/Policy");
var RoomInfoModule_1 = require("../../store/modules/RoomInfoModule");
var vuex_module_decorators_1 = require("vuex-module-decorators");
var axios_1 = require("axios");
var OfficeInfoModule_1 = require("../../store/modules/OfficeInfoModule");
var Room_1 = require("./Room");
var SetupProcedure_1 = require("../../components/dialogs/SetupProcedure");
var Loading_1 = require("../../components/globals/Loading");
var LoadingModule_1 = require("../../store/modules/LoadingModule");
var ReservedRow_1 = require("../../components/reserved/ReservedRow");
var room_no_1 = require("../../../common/src/utils/whereby/room_no");
var Manual_1 = require("../../components/dialogs/Manual");
var LogoutLink_1 = require("../../components/link/LogoutLink");
var HostTop = /** @class */ (function (_super) {
    __extends(HostTop, _super);
    function HostTop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tabs = null;
        _this.reservedRoomInfo = {
            officeId: '',
            reseredRoomWeeks: [
                { 1: {} }
            ]
        };
        return _this;
    }
    HostTop.prototype.isShowDetail = function (details) {
        return details.length > 0;
    };
    HostTop.prototype.isReservedRoomDaysVisible = function (reservedRoomDays) {
        return Object.keys(reservedRoomDays).length > 0;
    };
    HostTop.prototype.loadStart = function () {
        this.setLoading(true);
    };
    HostTop.prototype.loadEnd = function () {
        this.setLoading(false);
    };
    HostTop.prototype.setLoading = function (loading) {
        var storeInstance = vuex_module_decorators_1.getModule(LoadingModule_1.default, this.$store);
        storeInstance.setLoading(loading);
    };
    /**

     */
    HostTop.prototype.roomCreate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var self_, url_, params, authToken, result, storeInstance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self_ = this;
                        self_.loadStart();
                        url_ = self_.$invokeUrlMaker.create('make_room');
                        params = JSON.stringify({
                            officeId: self_.getOfficeId()
                        });
                        return [4 /*yield*/, this.$cognito.authToken()];
                    case 1:
                        authToken = _a.sent();
                        return [4 /*yield*/, axios_1.default.post(url_, params, {
                                headers: {
                                    Authorization: authToken
                                }
                            })];
                    case 2:
                        result = _a.sent();
                        storeInstance = vuex_module_decorators_1.getModule(RoomInfoModule_1.default, this.$store);
                        storeInstance.setRoomNo(result.data['roomNo']);
                        storeInstance.setRoomUrl(result.data['roomUrl']);
                        storeInstance.setRoomCreated(true);
                        storeInstance.setHostRoomUrl(result.data['hostRoomUrl']);
                        self_.loadEnd();
                        return [2 /*return*/];
                }
            });
        });
    };
    HostTop.prototype.isRoomCreated = function () {
        var storeInstance = vuex_module_decorators_1.getModule(RoomInfoModule_1.default, this.$store);
        return storeInstance.roomCreated;
    };
    HostTop.prototype.getRoomNo = function () {
        var storeInstance = vuex_module_decorators_1.getModule(RoomInfoModule_1.default, this.$store);
        return storeInstance.roomNo;
    };
    HostTop.prototype.getRoomNoArray = function () {
        return room_no_1.default.toString(this.getRoomNo()).split('');
    };
    HostTop.prototype.addNewRow = function () {
        if (!this.reservedRoomInfo || !this.reservedRoomInfo.reseredRoomWeeks.length) {
            this.reservedRoomInfo = this.getInitialReservedRoomInfo();
        }
        this.reservedRoomInfo.reseredRoomWeeks.push({ 1: {} });
    };
    HostTop.prototype.dayInfoUpdated = function (data) {
        if (!this.reservedRoomInfo || !this.reservedRoomInfo.reseredRoomWeeks.length) {
            this.reservedRoomInfo = this.getInitialReservedRoomInfo();
        }
        if (!this.reservedRoomInfo.reseredRoomWeeks[data['rowIndex']]) {
            this.reservedRoomInfo.reseredRoomWeeks[data['rowIndex']] = { 1: {} };
        }
        this.reservedRoomInfo.reseredRoomWeeks[data['rowIndex']][data['dayIndex']] = data['data'];
    };
    /**
     * 起動時の処理
     * */
    HostTop.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var authToken, userOfficeId, self_, url_, result, storeInstance, reservedRoomUrl_, reservedRoomInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadStart();
                        return [4 /*yield*/, this.$cognito.authToken()];
                    case 1:
                        authToken = _a.sent();
                        if (!authToken) {
                            this.$router.push({ path: '/' });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.getUserOfficeId()];
                    case 2:
                        userOfficeId = _a.sent();
                        if (this.getOfficeId() !== userOfficeId) {
                            this.$cognito.logout();
                            this.$router.push({ path: '/' });
                            return [2 /*return*/];
                        }
                        self_ = this;
                        url_ = self_.$invokeUrlMaker.create("office/name/" + this.getOfficeId());
                        return [4 /*yield*/, axios_1.default.get(url_)];
                    case 3:
                        result = _a.sent();
                        if (!result.data['officeName']) {
                            this.$cognito.logout();
                            this.$router.push({ path: '/' });
                            return [2 /*return*/];
                        }
                        storeInstance = vuex_module_decorators_1.getModule(OfficeInfoModule_1.default, this.$store);
                        storeInstance.setOfficeName(result.data['officeName']);
                        reservedRoomUrl_ = self_.$invokeUrlMaker.create("office/reserved/" + this.getOfficeId());
                        return [4 /*yield*/, axios_1.default.post(reservedRoomUrl_, {}, {
                                headers: {
                                    Authorization: authToken
                                }
                            })];
                    case 4:
                        reservedRoomInfo = _a.sent();
                        if (reservedRoomInfo.data['roomInfo'] && reservedRoomInfo.data['roomInfo']['reseredRoomWeeks'].length) {
                            this.reservedRoomInfo = reservedRoomInfo.data['roomInfo'];
                        }
                        this.loadEnd();
                        return [2 /*return*/];
                }
            });
        });
    };
    HostTop.prototype.getInitialReservedRoomInfo = function () {
        return {
            officeId: '',
            reseredRoomWeeks: [{ 1: {} }]
        };
    };
    HostTop.prototype.getUserOfficeId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var officeId, attributes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        officeId = '';
                        return [4 /*yield*/, this.$cognito.getUserAttributes()];
                    case 1:
                        attributes = _a.sent();
                        attributes.some(function (userAttribute) {
                            if (userAttribute.getName() === 'custom:office_id') {
                                officeId = userAttribute.getValue();
                                return true;
                            }
                        });
                        return [2 /*return*/, officeId];
                }
            });
        });
    };
    HostTop.prototype.isMeetingStarted = function () {
        var storeInstance = vuex_module_decorators_1.getModule(RoomInfoModule_1.default, this.$store);
        return storeInstance.meetingStarted;
    };
    /**
     */
    HostTop.prototype.startRehabOnline = function () {
        var storeInstance = vuex_module_decorators_1.getModule(RoomInfoModule_1.default, this.$store);
        storeInstance.setMeetingStarted(true);
    };
    HostTop.prototype.getOfficeId = function () {
        return this.$route.params['office_id'];
    };
    HostTop = __decorate([
        vue_property_decorator_1.Component({
            components: {
                ReservedRow: ReservedRow_1.default,
                LogoutLink: LogoutLink_1.default,
                Loading: Loading_1.default,
                SetupProcedure: SetupProcedure_1.default,
                Room: Room_1.default,
                Policy: Policy_1.default,
                AppHeader: AppHeader_1.default,
                ExternalLink: ExternalLink_1.default,
                Manual: Manual_1.default
            }
        })
    ], HostTop);
    return HostTop;
}(vue_property_decorator_1.Vue));
exports.default = HostTop;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/host/Top.vue
// module id = QRx6
// module chunks = 1